import StoreInfo from './StoreInfo.jsx';
import { Button, PrevButton, ButtonGroup } from '../ESignApplicationContainer.jsx';
import { useNavigate } from 'react-router-dom';
import useIsMobile from '../hooks/useIsMobile.jsx';
import { ROUTES } from 'App.js';
import useBusinessNumber from '../hooks/useBusinessNumber.jsx';
import useRedirect from '../hooks/useRedirect.jsx';

export default function StoreInfoScreen() {
  const { businessNumber } = useBusinessNumber();
  const { redirectUrl } = useRedirect();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const moveToNext = async () => {
    navigate(
      `${ROUTES.eSignAgreement}?businessNumber=${businessNumber}${redirectUrl ? `&redirectUrl=${redirectUrl}` : ''}`
    );
  };

  const moveToPrev = () => {
    navigate(ROUTES.eSign);
  };

  return (
    <>
      {/* 화면용 렌더링 */}
      <StoreInfo isMobile={isMobile} documentRefs={null} />

      <ButtonGroup>
        {!redirectUrl && <PrevButton onClick={moveToPrev}>이전 페이지</PrevButton>}
        <Button onClick={moveToNext}>다음 페이지</Button>
      </ButtonGroup>
    </>
  );
}
